export const SET_INSIGHT='SET_INSIGHT';
export const GET_INSIGHT='GET_INSIGHT';

export const INSIGHT_ACTION='INSIGHT_ACTION';
export const RESET_PAYLOAD='RESET_PAYLOAD';
